import { call, getContext, put, takeEvery } from "redux-saga/effects";
import { CONTEXT } from "@const/redux";
import {
  createManualVerificationSuccess,
  createManualVerificationFailure,
} from "./actions";
import { createManualVerificationActionTypes } from "./actionTypes";
import { completeMultipartUpload, uploadFilesSaga } from "../upload/saga";
import { removeEmptyKeys } from "@helpers/common";

const createManualVerificationAsync = ({ VerificationsService, body }) => {
  if (!VerificationsService) {
    console.log("Required service is missing");
    return;
  }

  return VerificationsService.createManualVerification(body);
};

function* createManualVerification({ payload }) {
  try {
    const { firstPageFileId, secondPageFileId, selfieFileId } = payload;

    const { VerificationsService, FilesService } = yield getContext(
      CONTEXT.SERVICES,
    );

    const files = [firstPageFileId, secondPageFileId, selfieFileId].filter(
      (item) => item,
    );

    const uploadedFiles = yield call(uploadFilesSaga, files);

    yield call(completeMultipartUpload, { FilesService, uploadedFiles });

    const body = {
      ...payload,
      firstPageFileId: uploadedFiles[0].fileId,
      secondPageFileId: secondPageFileId ? uploadedFiles[1].fileId : undefined,
      selfieFileId: uploadedFiles[secondPageFileId ? 2 : 1].fileId,
    };

    yield call(createManualVerificationAsync, {
      VerificationsService,
      body: removeEmptyKeys(body),
    });

    yield put(createManualVerificationSuccess());
  } catch (error) {
    const { ToasterService } = yield getContext(CONTEXT.SERVICES);

    ToasterService.errorTranslated(
      error?.message || error.error?.message || "Something went wrong",
    );

    yield put(createManualVerificationFailure(error));
  }
}

export function* watchCreateManualVerification() {
  yield takeEvery(
    createManualVerificationActionTypes.request,
    createManualVerification,
  );
}
